import { get, patch, post } from '../Services/http';
import { translate } from '../Services/translation';
import { load } from '../Actions/Cart.action';
import {
    WISHLIST_ADD,
    WISHLIST_ADD_ALL_TO_LIST_MESSAGE,
    WISHLIST_SET_ACTIVE,
    WISHLIST_SHOW_ACTIVE,
    WISHLIST_ADD_SHARED,
    WISHLIST_UPDATE_WISHLIST_NAME,
    WISHLIST_ADD_TO_CART,
    REMOVE_ERROR,
    WISHLIST_ADD_ALL_TO_CART,
    WISHLIST_GET,
    WISHLIST_GET_LINK,
    WISHLIST_GET_ALL,
    WISHLIST_GET_SUMMARY,
    WISHLIST_DELETE,
    WISHLIST_DELETE_ITEM,
    WISHLIST_SET_IN_WISHLIST,
    WISHLIST_SET_INCLUDED_IN_WISHLISTS,
} from '../constants';

export const add = (wishlistName, articleNumber, quantity = 1) => (
    dispatch
) => {
    return post('/api/wishlist/add', {
        wishlistName: wishlistName || translate('wishlist.default'),
        articleNumber: articleNumber,
        quantity: parseInt(quantity),
    })
        .then(() => {
            dispatch({
                type: WISHLIST_ADD,
                payload: {
                    addWishlist: {
                        success: true,
                        message: translate('wishlist.add.success'),
                    },
                },
            });
            return true;
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD,
                payload: {
                    success: false,
                    error: ex,
                    message: translate('wishlist.error'),
                },
            });
            throw ex;
        });
};

export const addAll = (wishlistName) => (dispatch) => {
    return post('/api/wishlist/addall', {
        WishlistName: wishlistName || translate('wishlist.default'),
    })
        .then(() => {
            dispatch({
                type: WISHLIST_ADD_ALL_TO_LIST_MESSAGE,
                payload: {
                    success: true,
                    message: translate('wishlist.addall.success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD_ALL_TO_LIST_MESSAGE,
                payload: {
                    success: false,
                    error: ex,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const updateWishlistName = (previousName, newName) => (dispatch) => {
    return patch('/api/wishlist/wishlistname', {
        previousName: previousName,
        newName: newName,
    })
        .then(() => {
            dispatch({
                type: WISHLIST_UPDATE_WISHLIST_NAME,
                payload: {
                    previousName,
                    newName,
                    success: true,
                    message: translate('wishlist.update.success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_UPDATE_WISHLIST_NAME,
                payload: {
                    success: false,
                    error: ex,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const addToCart = (articleNumber, quantity) => (dispatch) => {
    return post('/api/wishlist/addtocart', {
        articleNumber: articleNumber,
        quantity: parseInt(quantity),
    })
        .then(() => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    addToCart: {
                        success: true,
                        message: translate('wishlist.addtocart.success'),
                    },
                },
            });
        })
        .finally(() => {
            dispatch(load());
            setTimeout(() => {
                dispatch({
                    type: REMOVE_ERROR,
                    payload: {
                        success: true,
                    },
                });
            }, 3000);
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD_TO_CART,
                payload: {
                    success: false,
                    error: ex,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const addAllToCart = (wishlistName) => (dispatch) => {
    return post('/api/wishlist/addalltocart', {
        wishlistName: wishlistName,
    })
        .then(() => {
            dispatch({
                type: WISHLIST_ADD_ALL_TO_CART,
                payload: {
                    addAllToCart: {
                        success: true,
                        message: translate('wishlist.addalltocart.success'),
                    },
                },
            });
        })
        .finally(() => {
            dispatch(load());
            setTimeout(() => {
                dispatch({
                    type: REMOVE_ERROR,
                    payload: {
                        success: true,
                    },
                });
            }, 3000);
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_ADD_ALL_TO_CART,
                payload: {
                    success: false,
                    error: ex,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const getWishlist = (wishlistName) => (dispatch) => {
    return get(`/api/wishlist/getwishlist/${wishlistName}`, {
        wishlistName: wishlistName,
    })
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_GET,
                payload: {
                    success: true,
                    message: 'Successfull fetch list',
                    list: result,
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_GET,
                payload: {
                    success: false,
                    error: ex,
                    message: 'There was an error',
                },
            });
        });
};

export const getWishlistSummary = () => (dispatch) => {
    return get(`/api/wishlist/summary`)
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_GET_SUMMARY,
                payload: {
                    success: true,
                    summary: result,
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_GET_SUMMARY,
                payload: {
                    success: false,
                    error: ex,
                    message: 'There was an error',
                },
            });
        });
};

export const setActiveWishlist = (wishlistName) => (dispatch) => {
    return dispatch({
        type: WISHLIST_SET_ACTIVE,
        payload: wishlistName,
    });
};

export const showWishlistDrawer = (show) => (dispatch) => {
    return dispatch({
        type: WISHLIST_SHOW_ACTIVE,
        payload: show,
    });
};

export const getAllWishlists = () => (dispatch) => {
    return get('/api/wishlist/getallwishlists')
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: WISHLIST_GET_ALL,
                payload: {
                    success: true,
                    lists: result,
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_GET_ALL,
                payload: {
                    success: false,
                    error: ex,
                    message: 'There was an error',
                },
            });
        });
};

export const addSharedWishlist = (wishlistId) => (dispatch) => {
    return post('/api/wishlist/addshared', {
        wishlistId: wishlistId,
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(
                    'Failed to add wishlist. Check response for more information.'
                );
            }
            return response.json();
        })
        .then((result) => {
            const successPayload = {
                success: true,
                message: 'Shared wishlist added successfully.',
                wishlistName: result.wishlistName,
            };

            dispatch({
                type: WISHLIST_ADD_SHARED,
                payload: successPayload,
            });
            return successPayload;
        })
        .catch((error) => {
            const errorPayload = {
                success: false,
                error: error.message,
                message: 'There was an error when adding the shared wishlist.',
            };

            dispatch({
                type: WISHLIST_ADD_SHARED,
                payload: errorPayload,
            });
            throw errorPayload;
        });
};

export const getShareLink = (wishlistId) => (dispatch) => {
    return get(`/api/wishlist/sharelink/${wishlistId}`, { wishlistId })
        .then((response) => {
            if (!response.ok) {
                throw new Error(
                    'Failed to get share link. Check response for more information.'
                );
            }
            return response.text().then((link) => {
                dispatch({
                    type: WISHLIST_GET_LINK,
                    payload: {
                        success: true,
                        message: 'Successfully fetched link',
                        link: link,
                    },
                });
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_GET_LINK,
                payload: {
                    success: false,
                    error: ex.message,
                    message: 'There was an error',
                },
            });
        });
};

export const deleteWishlist = (wishlistName) => (dispatch) => {
    return post('/api/wishlist/deletelist', {
        wishlistName: wishlistName,
    })
        .then(() => {
            dispatch({
                type: WISHLIST_DELETE,
                payload: {
                    success: true,
                    message: translate('wishlist.delete.success'),
                },
            });
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_DELETE,
                payload: {
                    success: false,
                    error: ex,
                    message: translate('wishlist.error'),
                },
            });
        });
};

export const deleteWishlistItem = (sortIndex, wishlistName) => (dispatch) => {
    return post('/api/wishlist/deletelistitem', {
        sortIndex: sortIndex,
        wishlistName: wishlistName,
    })
        .then(() => {
            dispatch({
                type: WISHLIST_DELETE_ITEM,
                payload: {
                    sortIndex,
                    success: true,
                    message: translate('wishlist.delete.success'),
                },
            });
            return true;
        })
        .catch((ex) => {
            dispatch({
                type: WISHLIST_DELETE_ITEM,
                payload: {
                    success: false,
                    error: ex,
                    message: translate('wishlist.error'),
                },
            });
            throw ex;
        });
};

export const setIsInWishlist = (inWishlist) => (dispatch) => {
    return dispatch({
        type: WISHLIST_SET_IN_WISHLIST,
        inWishlist,
    });
};

export const setIncludedInWishlists = (includedInWishlists) => (dispatch) => {
    return dispatch({
        type: WISHLIST_SET_INCLUDED_IN_WISHLISTS,
        includedInWishlists,
    });
};
